import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import DynamicTemplateComponent from '../DynamicTemplateComponent/DynamicTemplateComponent'

import WithRender from './RemoteTemplateComponent.html';

@WithRender
@Component({
    name: "RemoteTemplateComponent",
    components: {
        DynamicTemplateComponent
    },
})
export default class RemoteTemplateComponent extends Vue {

    @Prop({ default: "" })
    href! : string

    phref = ""

    template: string = ""


    @Watch('href')
    onHrefChange() {

      
        this.phref = this.href

        if (this.phref == "") {
            return
        }

        fetch(this.phref).then(response => {
            // TODO: 3 Add top-level wrapper div here (requires some adjustments)
            response.text().then(data => { this.template =  data })
        });

    }

    mounted() {
        this.onHrefChange()
    }
}

